import { useContext, useMemo } from 'react';
import { NativeContext, UseNativeState } from '../../context/native';

export const useNative = (): UseNativeState => {
  const context = useContext(NativeContext);

  return useMemo((): UseNativeState => context, Object.values(context));
};
